document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initHeroSliders();
  initTabs();
  initCarruseles();
  initProducto();
  initAcordeones();
  initContador();
  initFiltroProductos();
  initResenas();
});

function initResenas() {
  document.querySelectorAll('[data-mt-resenas]').forEach(function (root) {
    var toggleBtn = root.querySelector('[data-mt-resena-toggle]');
    var form = root.querySelector('[data-mt-resena-form]');
    if (toggleBtn && form) {
      toggleBtn.addEventListener('click', function () {
        form.hidden = !form.hidden;
        if (!form.hidden) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    var ratingWrap = root.querySelector('[data-mt-resena-rating]');
    if (ratingWrap) {
      var radios = ratingWrap.querySelectorAll('input[type="radio"]');
      var stars = ratingWrap.querySelectorAll('[data-mt-star]');
      function pintarEstrellas() {
        var seleccionado = ratingWrap.querySelector('input:checked');
        var valor = seleccionado ? parseInt(seleccionado.value, 10) : 0;
        stars.forEach(function (star, i) {
          star.setAttribute('fill', i < valor ? '#f4b400' : '#ddd');
        });
      }
      radios.forEach(function (radio, i) {
        stars[i].addEventListener('click', function () { radio.checked = true; pintarEstrellas(); });
      });
      pintarEstrellas();
    }

    var ordenSelect = root.querySelector('[data-mt-resenas-orden]');
    var lista = root.querySelector('[data-mt-resenas-lista]');
    if (ordenSelect && lista) {
      var original = Array.prototype.slice.call(lista.children);
      ordenSelect.addEventListener('change', function () {
        var items = Array.prototype.slice.call(lista.children);
        if (ordenSelect.value === 'mejor') {
          items.sort(function (a, b) { return parseInt(b.dataset.rating, 10) - parseInt(a.dataset.rating, 10); });
        } else if (ordenSelect.value === 'peor') {
          items.sort(function (a, b) { return parseInt(a.dataset.rating, 10) - parseInt(b.dataset.rating, 10); });
        } else {
          items = original.slice();
        }
        items.forEach(function (item) { lista.appendChild(item); });
      });
    }
  });
}

function initFiltroProductos() {
  document.querySelectorAll('[data-mt-filtro-productos]').forEach(function (root) {
    var checks = root.querySelectorAll('[data-mt-filtro-categoria]');
    var minInput = root.querySelector('[data-mt-filtro-precio-min]');
    var maxInput = root.querySelector('[data-mt-filtro-precio-max]');
    var limpiarBtn = root.querySelector('[data-mt-filtro-limpiar]');
    var cards = root.querySelectorAll('[data-mt-producto-card]');
    var conteoEl = root.querySelector('[data-mt-filtro-conteo]');
    var vacioEl = root.querySelector('[data-mt-filtro-vacio]');
    var conteoSufijo = conteoEl ? conteoEl.textContent.replace(/^\s*\d+\s*/, '').trim() : '';

    function aplicar() {
      var categoriasActivas = [...checks].filter(function (c) { return c.checked; }).map(function (c) { return c.value; });
      var min = minInput && minInput.value !== '' ? parseFloat(minInput.value) : null;
      var max = maxInput && maxInput.value !== '' ? parseFloat(maxInput.value) : null;
      var visibles = 0;

      cards.forEach(function (card) {
        var colecciones = (card.dataset.colecciones || '').split(',').filter(Boolean);
        var precio = parseFloat(card.dataset.precio || '0');

        var pasaCategoria = categoriasActivas.length === 0 || categoriasActivas.some(function (c) { return colecciones.indexOf(c) !== -1; });
        var pasaMin = min === null || precio >= min;
        var pasaMax = max === null || precio <= max;

        var visible = pasaCategoria && pasaMin && pasaMax;
        card.style.display = visible ? '' : 'none';
        if (visible) visibles++;
      });

      if (conteoEl) conteoEl.textContent = visibles + ' ' + conteoSufijo;
      if (vacioEl) vacioEl.hidden = visibles !== 0;
    }

    checks.forEach(function (c) { c.addEventListener('change', aplicar); });
    if (minInput) minInput.addEventListener('input', aplicar);
    if (maxInput) maxInput.addEventListener('input', aplicar);
    if (limpiarBtn) {
      limpiarBtn.addEventListener('click', function () {
        checks.forEach(function (c) { c.checked = false; });
        if (minInput) minInput.value = '';
        if (maxInput) maxInput.value = '';
        aplicar();
      });
    }
  });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-count]');
  if (!els.length) return;
  function animate(el) {
    var target = parseInt(el.dataset.target, 10) || 0;
    var duration = 1400;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      el.textContent = Math.floor(progress * target);
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target;
    }
    requestAnimationFrame(step);
  }
  if (!('IntersectionObserver' in window)) {
    els.forEach(animate);
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animate(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initHeroSliders() {
  document.querySelectorAll('[data-mt-hero]').forEach(function (hero) {
    var track = hero.querySelector('.mt-hero__track');
    var slides = hero.querySelectorAll('.mt-hero__slide');
    var dots = hero.querySelectorAll('.mt-hero__dot');
    if (!track || slides.length < 2) return;
    var index = 0;
    var autoplay = hero.dataset.autoplay === 'true';
    var delay = parseInt(hero.dataset.delay || '6000', 10);
    var timer = null;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { go(index + 1); }, delay);
    }
    function stop() { if (timer) clearInterval(timer); }

    hero.querySelectorAll('.mt-hero__nav--prev').forEach(function (btn) { btn.addEventListener('click', function () { go(index - 1); start(); }); });
    hero.querySelectorAll('.mt-hero__nav--next').forEach(function (btn) { btn.addEventListener('click', function () { go(index + 1); start(); }); });
    dots.forEach(function (dot, di) { dot.addEventListener('click', function () { go(di); start(); }); });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    go(0);
    start();
  });
}

function initTabs() {
  document.querySelectorAll('[data-mt-tabs]').forEach(function (wrap) {
    var buttons = wrap.querySelectorAll('.mt-tabs__btn');
    var panels = wrap.querySelectorAll('.mt-tabs__panel');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.target;
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === target); });
      });
    });
  });
}

function initCarruseles() {
  document.querySelectorAll('[data-mt-carrusel]').forEach(function (wrap) {
    var track = wrap.querySelector('.mt-carrusel');
    var prev = wrap.querySelector('.mt-carrusel__btn--prev');
    var next = wrap.querySelector('.mt-carrusel__btn--next');
    if (!track) return;
    function scrollByCards(dir) {
      var card = track.querySelector('.mt-card');
      var amount = card ? card.getBoundingClientRect().width + 24 : 280;
      track.scrollBy({ left: dir * amount * 2, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByCards(-1); });
    if (next) next.addEventListener('click', function () { scrollByCards(1); });
  });
}

function initAcordeones() {
  document.querySelectorAll('.mt-acordeon__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.mt-acordeon__item');
      var panel = item.querySelector('.mt-acordeon__panel');
      var inner = panel.querySelector('.mt-acordeon__panel-inner');
      var isOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.mt-acordeon__item').forEach(function (i) {
        i.classList.remove('is-open');
        i.querySelector('.mt-acordeon__panel').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('is-open');
        panel.style.maxHeight = inner.offsetHeight + 'px';
      }
    });
  });
}

function initProducto() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-mt-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-mt-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = root.querySelector('[data-mt-price]');
    var comparePriceEl = root.querySelector('[data-mt-compare-price]');
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    var mainImg = root.querySelector('[data-mt-main-image]');
    var thumbs = root.querySelectorAll('[data-mt-thumb]');
    var optionInputs = root.querySelectorAll('[data-mt-option]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          mainImg.src = thumb.dataset.full || thumb.querySelector('img').src;
        }
      });
    });

    function selectedOptions() {
      var vals = [];
      var groups = {};
      optionInputs.forEach(function (input) {
        if (input.type === 'radio' && !input.checked) return;
        groups[input.dataset.mtOption] = input.value;
      });
      return groups;
    }

    function findVariant() {
      var sel = selectedOptions();
      return variants.find(function (v) {
        return Object.keys(sel).every(function (key) {
          return String(v.options_by_name && v.options_by_name[key]) === String(sel[key]) || v.title_parts.indexOf(sel[key]) !== -1;
        });
      });
    }

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    }

    function updateUI() {
      if (!optionInputs.length) return;
      var variant = findVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? submitBtn.dataset.labelAvailable : submitBtn.dataset.labelSoldOut;
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        root.querySelectorAll('[data-mt-option="' + input.dataset.mtOption + '"]').forEach(function (i) {
          i.closest('.mt-swatch').classList.toggle('is-selected', i === input);
        });
        updateUI();
      });
    });

    var qtyWrap = root.querySelector('[data-mt-qty]');
    if (qtyWrap) {
      var qtyInput = qtyWrap.querySelector('input');
      qtyWrap.querySelector('[data-mt-qty-minus]').addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      });
      qtyWrap.querySelector('[data-mt-qty-plus]').addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      });
    }

    updateUI();
  });
}
